import { PointerSensor } from "@dnd-kit/core";

export class IgnoreInteractiveSensor extends PointerSensor {
  static activators = [
    {
      eventName: "onPointerDown" as const,
      handler: ({ nativeEvent: event }) => {
        if (
          !event.isPrimary ||
          event.button !== 0 ||
          isInputElement(event.target)
        ) {
          return false;
        }

        return true;
      },
    },
  ];
}

function isInputElement(element: HTMLElement | null): boolean {
  const tagName = element.tagName.toLowerCase();
  if (tagName === "input" || tagName === "textarea") {
    return true;
  }

  // any parent is contenteditable
  if (element?.closest("[contenteditable]")) {
    return true;
  }

  return false;
}
